import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { useDeviceInfo, useI18n, useLicenses } from '~Hooks';
import SettingsToggle, { Setting } from '~Scenes/Handy/Components/SettingsToggle';
import { useStorage } from '~Components/Storage';

const StaffSettings = () => {
  const { i18n } = useI18n();
  const licenses = useLicenses();
  const [storage, updateStorage] = useStorage();

  const deviceInfo = useDeviceInfo();

  const SETTING_LIST: Setting[] = [
    {
      key: 'disableStaffTimeout',
      label: i18n('Settings.DisableStaffTimeout'),
      description: i18n('Settings.DisableStaffTimeout.Text'),
    },
    {
      key: 'staffCanViewOwnReport',
      label: i18n('Settings.Reports.AllowStaffReport'),
      description: i18n('Settings.Reports.AllowStaffReport.SubLabel'),
    },
    {
      key: 'showDetailedSalesBreakdown',
      label: i18n('Settings.Reports.CategoryBreakdown'),
      description: i18n('Settings.Reports.CategoryBreakdown.SubLabel'),
    },
  ];

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.StaffTitle')}>
      <SettingsToggle settingList={SETTING_LIST} />
    </HandyPageWrapper>
  );
};

export default StaffSettings;
